import Vue from 'vue';

const END_POINT = '/payrollSummary';

const getPayrollSummary = (id) => Vue.axios.get(END_POINT + '/' + id);

const getAllPayrollSummaries = (data) =>
  Vue.axios.get(END_POINT, { params: data });

const createPayrollSummary = (payrollSummary) =>
  Vue.axios.post(END_POINT, payrollSummary);

const createAllPayrollSummaries = (PayrollSummaries) =>
  Vue.axios.post(END_POINT + '/all', PayrollSummaries);

const updatePayrollSummary = (payrollSummary) =>
  Vue.axios.put(END_POINT + '/' + payrollSummary.id, payrollSummary);

const deletePayrollSummary = (id) => Vue.axios.delete(END_POINT + '/' + id);

export {
  getPayrollSummary,
  getAllPayrollSummaries,
  createPayrollSummary,
  createAllPayrollSummaries,
  updatePayrollSummary,
  deletePayrollSummary,
};
